import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import * as actions from "./actions"

import Footer from "./components/Footer"

interface OldUIInit {
    start: (element: HTMLElement | undefined | null, itemId: number) => void
    updateElements: (values: OldUIIPEField[], initiatorIpeId: string) => void
}

const init = (
    store: AppStore,
    oldUIContext: OldUIContext.OldUIContext,
): OldUIInit => {
    return {
        start: (
            element: HTMLElement | undefined | null,
            itemId: number,
        ): void => {
            if (!element) {
                throw new Error("Element should have value")
            }

            const {
                resourceHeader: {
                    resource: { itemType },
                },
            } = store.getState()
            if (itemType != "Wiki") {
                store.dispatch(actions.initialize(itemId))
            }

            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <Footer />
                    </OldUIContext.Provider>
                </Provider>,
            )
        },

        updateElements: (
            values: OldUIIPEField[],
            initiatorIpeId: string,
        ): void => {
            const {
                resourceHeader: {
                    resource: { resourceType, id },
                },
            } = store.getState()

            if (resourceType == "Item") {
                if (
                    isCurrentItemStatusIpeId(id, initiatorIpeId) ||
                    values.some((value) =>
                        isCurrentItemStatusIpeId(id, value.ID),
                    )
                ) {
                    store.dispatch(actions.requestStateTransitionButtons())
                }
            }
        },
    }
}

const getStatusRegex = (id: number): RegExp =>
    new RegExp("^(item|meeting)." + id.toString() + ".7$")

const isCurrentItemStatusIpeId = (
    itemId: number | undefined,
    ipeId: string | null,
): boolean => {
    if (itemId === undefined || ipeId === null) {
        return false
    }
    return getStatusRegex(itemId).test(ipeId)
}

export default init
